.footerDialog {
    width: 360px;
    max-width: calc(100vw - var(--bi-scale-8x));
    color: var(--bi-color-text, #001932);
    background-color: var(--bi-basic-white);
    font: var(--bi-font-body-medium);
    /* The trigger lives inside the footer's nowrap link row; reset so the dialog text wraps. */
    white-space: normal;
}
